import { createRoot } from "react-dom/client";
import { WidgetType } from "@codemirror/view";

import { Tabular } from "components/organisms/manuscript/editor/visual/table";

const deferUnmount =
    typeof queueMicrotask === "function" ? queueMicrotask : (callback) => window.setTimeout(callback, 0);

export class TabularWidget extends WidgetType {
    static roots = new WeakMap();

    constructor(parsedTableData, tabularNode, content, tableNode, directTableChild) {
        super();
        this.parsedTableData = parsedTableData;
        this.tabularNode = tabularNode;
        this.content = content;
        this.tableNode = tableNode;
        this.directTableChild = directTableChild;
    }

    renderInDOMContainer(children, element) {
        const root = TabularWidget.roots.get(element) || createRoot(element);
        if (!TabularWidget.roots.has(element)) {
            TabularWidget.roots.set(element, root);
        }
        root.render(children);
    }

    toDOM(view) {
        const element = document.createElement("div");
        element.classList.add("ol-cm-tabular");
        if (this.tableNode) {
            element.classList.add("ol-cm-environment-table");
        }
        this.renderInDOMContainer(
            <Tabular
                view={view}
                tabularNode={this.tabularNode}
                parsedTableData={this.parsedTableData}
                tableNode={this.tableNode}
                directTableChild={this.directTableChild}
            />,
            element,
        );
        return element;
    }

    eq(widget) {
        return (
            this.tabularNode.from === widget.tabularNode.from &&
            this.tableNode?.from === widget.tableNode?.from &&
            this.tableNode?.to === widget.tableNode?.to &&
            this.content === widget.content &&
            this.directTableChild === widget.directTableChild
        );
    }

    updateDOM(element, view) {
        this.renderInDOMContainer(
            <Tabular
                view={view}
                tabularNode={this.tabularNode}
                parsedTableData={this.parsedTableData}
                tableNode={this.tableNode}
                directTableChild={this.directTableChild}
            />,
            element,
        );
        return true;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }

    get estimatedHeight() {
        return this.parsedTableData.table.rows.length * 50;
    }

    destroy(element) {
        const root = TabularWidget.roots.get(element);
        if (root) {
            TabularWidget.roots.delete(element);
            deferUnmount(() => {
                root.unmount();
            });
        }
    }
}
